<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection :text="(id) ? 'Editar grupo' : 'Crear grupo'" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Guardar" :cancelUrl="{ name: 'company.admin.group.index' }" :submitting="submitting" :errors="validationExternal" @submit="submit" v-if="!loading">
				<template #body>
					<CommonFormInputText v-model="target.name" title="Nombre" placeholder="Ingrese un nombre" :validation="validation.name" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { reactive, onBeforeMount } from 'vue';
	import router from '@/router';
	import _ from 'lodash';
	import moment from 'moment';
	import useVuelidate from '@vuelidate/core';
	import { required, minLength, maxLength } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import CompanyAdminGroupRepository from '@/repositories/modules/Company/Admin/Group';

	export default {
		props: {
			id: String
		},
		setup(props) {
			const { loading, submitting, validationExternal, catchError } = composableForm();

			const target = reactive({
				id: null,
				name: null,
				config: {}
			});

			const validation = useVuelidate({
				name: {
					required,
					minLength: minLength(3),
					maxLength: maxLength(150)
				}
			}, target);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;

				if(props.id != undefined) {
					await CompanyAdminGroupRepository.update(props.id, target).then(() => {
						router.push({ name: 'company.admin.group.index' });
					}).catch(catchError);
				}else{
					await CompanyAdminGroupRepository.store(target).then(() => {
						router.push({ name: 'company.admin.group.index' });
					}).catch(catchError);
				}

				submitting.value = false;
			}

			onBeforeMount(async () => {
				if(props.id != undefined) {
					await CompanyAdminGroupRepository.show(props.id).then((response) => {
						Object.assign(target, response.data);
						if(target.permissions == null) target.permissions = [];
						if(target.phone == null) target.phone = '-';
					}).catch((e) => {
						catchError(e);
						router.push({ name: `company.admin.group.index` });
					});
				}

				loading.value = false;
			});

			return { loading, target, submit, submitting, validation, validationExternal };
		}
	}
</script>